import { ArrayInput, SimpleFormIterator, ReferenceInput } from 'react-admin'
import { Paper } from '@mui/material'

export const PaperArrayReferenceInput = ({ label, source, reference }) => {
  return (
    <Paper
      sx={{
        p: 3,
        mb: 2,
        backgroundColor: 'background.paper',
        borderRadius: 2,
        border: '2px solid',
        borderColor: 'divider',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <ArrayInput source={source} label={label}>
        <SimpleFormIterator
          sx={{
            '& > ul, & .RaSimpleFormIterator-list': {
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 2,
              listStyle: 'none',
              padding: 0,
              margin: 0,
            },
            '& .RaSimpleFormIterator-line': {
              margin: 0,
              border: 'none',
              width: '100%',
              backgroundColor: 'background.default',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              padding: 2,
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '& .RaSimpleFormIterator-action': {
                marginLeft: 'auto',
                flexShrink: 0,
              },
              '& > div:first-of-type': {
                flex: 1,
                minWidth: 0,
              },
            },
          }}
        >
          <ReferenceInput source="" reference={reference} fullWidth />
        </SimpleFormIterator>
      </ArrayInput>
    </Paper>
  )
}

